import { useMutation, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IPartCategory } from "../models/Part";

export default function useCategoriesMutations() {
  const { post, put } = useApiHelper();
  const queryClient = useQueryClient();

  const invalidateCategoryQueries = () => {
    queryClient.invalidateQueries(["categories"]);
    queryClient.invalidateQueries(["categories", "partial"]);
  };

  const create = useMutation(
    (category: IPartCategory) => post(`/part/categories`, category),
    {
      onSuccess: () => {
        invalidateCategoryQueries();
      },
    }
  );

  const update = useMutation(
    (category: IPartCategory) => put(`/part/categories/${category.id}`, category),
    {
      onSuccess: () => {
        invalidateCategoryQueries();
      },
    }
  );

  const bulkUpdatePartCategories = useMutation(
    (body: any) => post(`/part/categories/bulk`, body),
    {
      onSuccess: () => {
        invalidateCategoryQueries();
        queryClient.invalidateQueries(["categoryParts"]);
        queryClient.invalidateQueries(["pagedTable"]);
      },
    }
  );

  const bulkAcceptPartCategories = useMutation(
    (body: any) => post(`/part/categories/bulk/accept`, body),
    {
      onSuccess: () => {
        invalidateCategoryQueries();
        queryClient.invalidateQueries(["categoryParts"]);
        queryClient.invalidateQueries(["pagedTable"]);
      },
    }
  );

  return {
    create,
    update,
    bulkUpdatePartCategories,
    bulkAcceptPartCategories,
  };
}
